import { useMemo } from "react";
import { Form, Col } from "antd";
import { renderField } from "./fieldRenderers";
import { buildValidationRules } from "../helper/validation";
import { getGridColSpan } from "../helper/formHelpers";
import dayjs from "../../../../../../utils/dayjs";

const DynamicField = ({
  field,
  disabled = false,
  showHints = true,
  restField = {},
  section_id = null,
}) => {
  // Build validation rules
  const validationRules = useMemo(
    () => buildValidationRules(field) || [],
    [field],
  );

  // Get grid column configuration
  const gridColConfig = useMemo(
    () => getGridColSpan(field.grid_span || 1),
    [field.grid_span],
  );

  return (
    <Col {...gridColConfig}>
      <Form.Item
        {...(restField || {})}
        name={section_id ? [section_id, field?.field_key] : field.field_key}
        label={field.label}
        //@ts-ignore
        rules={validationRules}
        valuePropName={field.field_type === "boolean" ? "checked" : "value"}
        layout="vertical"
        extra={
          showHints && field.is_ai_extractable && field.ai_extraction_hint
            ? field.ai_extraction_hint
            : ""
        }
        initialValue={field?.field_type === "date" ? dayjs() : undefined}
      >
        {renderField(field, disabled || field?.is_readonly)}
      </Form.Item>
    </Col>
  );
};

export default DynamicField;
